import UnitedAmount from "../../united-amount";
import HfMarked from "../../hf-marked";
import React from "react";
import HFImage from "../../hf-image";
import {getCookie} from "../../../utils/crypto";
import {staticResourcesEndpoint} from "../../../utils/communication";
import {Link} from "react-router-dom";

export default function RecipeDetail({recipe, isLoading}: { recipe: Recipe | null, isLoading: boolean }) {
    if (isLoading) {
        return (
            <p>Loading...</p>
        );
    } else if (recipe === null) {
        return (
            <p>Recipe not found</p>
        );
    }

    const buildEditLink = () => {
        return (<p className="text-8 text-sm">Edit this recipe? <Link to={"/cooking/recipe/" + recipe.publicId + "/edit"}
                                                                      className="text-primary-16">Transport.</Link>
        </p>);
    }

    return (<>
        <HFImage
            src={staticResourcesEndpoint + "/static/hfsitedata/cookinghf/" + recipe.publicId + ".JPG"}
            alt={recipe.name}
            className="w-full h-fit max-h-[480px] rounded-lg mr-8 object-cover bg-8"/>

        <div>
            <h1>{recipe?.name}</h1>
            <p className="text-8 font-bold">{recipe?.cuisineType?.name}</p>
            <p className="text-8 mt-8">{recipe?.description}</p>
        </div>

        <div className="flex">
            <div className="flex-1">
                <h3 className="pb-4 text-xl font-bold">Ingredients</h3>
                {recipe?.ingredients?.map(ingredient => (
                    <div key={ingredient.publicId} className="flex">
                        <span className="text-0 font-medium pr-2">{ingredient.ingredient!.name}</span>
                        <UnitedAmount amount={ingredient!.amount} unit={ingredient!.unit}/>
                    </div>))}
            </div>

            <div className="flex-1">
                <h3 className="pb-4 text-xl font-bold">Tools</h3>
                {recipe?.tools?.map(tool => (
                    <div key={tool.publicId} className="flex">
                        <span className="text-0 font-medium pr-2">{tool.tool!.name}</span>
                        <UnitedAmount amount={tool!.amount} unit={tool!.unit}/>
                    </div>))}
            </div>
        </div>

        <div>
            <h3 className="pb-4 text-xl font-bold">Steps</h3>
            <HfMarked>{recipe?.steps}</HfMarked>
        </div>

        <div>
            <h3 className="pb-4 text-xl font-bold">Tips</h3>
            <HfMarked>{recipe?.tips}</HfMarked>
        </div>

        <div>
            {buildEditLink()}
            <p className="text-8 text-sm">PublicID {recipe?.publicId}</p>
            <p className="text-8 text-sm">Created {recipe?.createdAt.toString()}</p>
            <p className="text-8 text-sm">Last Updated {recipe?.updatedAt.toString()}</p>
        </div>
    </>);
}